function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var NowplayingClient = /*#__PURE__*/function () {
  function NowplayingClient(_ref) {
    var server = _ref.server,
      playlistVersion = _ref.playlistVersion,
      scheduleVersion = _ref.scheduleVersion;
    _classCallCheck(this, NowplayingClient);
    this.server = server || 'https://nowplaying.publicradio.org';
    this.playlistVersion = playlistVersion || 'v2';
    this.scheduleVersion = scheduleVersion || 'v1';
    this.reconnectDelay = Math.random() * 3000;
    this.maxReconnectDelay = 60000;
    this.advice = {
      reconnect: 'yes'
    };
    this.connections = new Map();
  }
  _createClass(NowplayingClient, [{
    key: "_route",
    value: function _route(_ref2) {
      var server = _ref2.server,
        type = _ref2.type,
        service = _ref2.service,
        playlistVersion = _ref2.playlistVersion,
        scheduleVersion = _ref2.scheduleVersion;
      if (type === 'playlist') {
        return "".concat(server, "/").concat(type, "/").concat(service, "/").concat(playlistVersion);
      }
      if (type === 'potlatch') {
        return "".concat(server, "/").concat(type, "/").concat(service);
      }
      return "".concat(server, "/").concat(type, "/").concat(service, "/").concat(scheduleVersion);
    }
  }, {
    key: "connect",
    value: function connect(connection) {
      var websocket = new WebSocket(this._route(connection));
      websocket.addEventListener('open', function () {
        connection.reconnectDelay = Math.random() * 3000;
      });
      return websocket;
    }
  }, {
    key: "register_callback",
    value: function register_callback(service, type, callback) {
      var _connection$advice,
        _this = this,
        _connection$advice2;
      var connection = this.connections.get("".concat(type, "-").concat(service)) || {
        server: this.server,
        playlistVersion: this.playlistVersion,
        scheduleVersion: this.scheduleVersion,
        type: type,
        service: service,
        advice: this.advice,
        reconnectDelay: this.reconnectDelay
      };
      this.connections.set("".concat(type, "-").concat(service), connection);
      if (((_connection$advice = connection.advice) === null || _connection$advice === void 0 ? void 0 : _connection$advice.reconnect) === 'none') {
        return;
      }
      var websocket = this.connect(connection);
      websocket.onmessage = function (event) {
        var message = JSON.parse(event.data);
        connection.advice = message === null || message === void 0 ? void 0 : message.advice;
        callback(message === null || message === void 0 ? void 0 : message.data);
      };
      var closeHandler = function closeHandler() {
        setTimeout(function () {
          connection.reconnectDelay *= 2;
          _this.register_callback(service, type, callback);
        }, connection.reconnectDelay);
      };
      if (connection.reconnectDelay < this.maxReconnectDelay && ((_connection$advice2 = connection.advice) === null || _connection$advice2 === void 0 ? void 0 : _connection$advice2.reconnect) !== 'none') {
        websocket.addEventListener('close', closeHandler);
      }
      return {
        unregister: function unregister() {
          websocket.removeEventListener('close', closeHandler);
          websocket.close();
        }
      };
    }
  }]);
  return NowplayingClient;
}();
module.exports = NowplayingClient;
